// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2dA_k","range":"MonthRangeSwitch_range__3NK5E","disabled":"MonthRangeSwitch_disabled__ztO2O"};